import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';

const testimonials = [
  {
    name: '陈女士',
    age: 38,
    location: '上海',
    text: '关注熟女魅力已经两年了，这里的穿搭建议真的改变了我的穿衣风格。现在同事们都说我越来越有气质了！',
  },
  {
    name: '王女士',
    age: 42,
    location: '北京',
    text: '护肤保养专栏是我最喜欢的板块，按照文章里的方法坚持了三个月，皮肤状态明显改善，朋友都说看不出我已经42岁了。',
  },
  {
    name: '李女士',
    age: 35,
    location: '深圳',
    text: '熟女魅力的生活美学文章给了我很多灵感，现在我的家焕然一新，每天回家都觉得很幸福。感谢这个平台！',
  },
  {
    name: '张女士',
    age: 45,
    location: '杭州',
    text: '自我成长板块的文章让我在迷茫的时候找到了方向。40+不是终点，而是新生活的开始。感谢熟女魅力的陪伴。',
  },
];

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '熟女魅力是一个什么样的平台？',
    answer: '熟女魅力是一个专为30岁以上成熟女性打造的生活方式内容平台。我们围绕时尚穿搭、护肤保养、生活美学和自我成长四大主题，提供高质量的原创文章和实用指南，帮助每位熟女展现自信与优雅。',
  },
  {
    question: '网站的内容多久更新一次？',
    answer: '我们每周更新2-3篇原创文章，涵盖时尚穿搭、护肤保养、生活美学和自我成长等多个方向。同时，订阅用户还会收到每周精选内容推送，不错过任何精彩。',
  },
  {
    question: '如何获取最新的穿搭和保养建议？',
    answer: '你可以通过网站首页的订阅表单订阅我们的邮件资讯，每周都会收到最新的熟女穿搭、保养和生活美学内容。也可以关注我们的微博和小红书账号获取每日更新。',
  },
  {
    question: '网站内容是否适合所有年龄段的女性？',
    answer: '我们的核心读者群体是30-50岁的成熟女性，内容围绕这个年龄段女性的需求进行创作。不过，20多岁的年轻女性也可以从中获取穿搭和保养的灵感，50岁以上的女性同样能在这里找到共鸣。',
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于熟女魅力',
    description: '熟女魅力是一个专为30岁以上成熟女性打造的生活方式内容平台，提供时尚穿搭、护肤保养、生活美学与自我成长的优质内容。',
    url: 'https://elegantvibe.github.io/about',
    about: {
      '@type': 'Organization',
      name: '熟女魅力',
      description: '专注为30岁以上成熟女性提供时尚穿搭、护肤保养、生活美学与自我成长的优质内容平台。',
      url: 'https://elegantvibe.github.io/',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@shunvmeili.com',
        availableLanguage: 'Chinese',
      },
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('感谢你的留言！我们会尽快与你联系。');
      form.reset();
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9u4hetca23r0tr1aqdg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          name: formData.get('name') as string,
          email: formData.get('email') as string,
          subject: formData.get('subject') as string,
          message: formData.get('message') as string,
        }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setFormStatus('success');
        setFormMessage('感谢你的留言！我们会尽快与你联系。');
        form.reset();
      } else {
        setFormStatus('error');
        setFormMessage(responseText || '提交失败，请稍后再试。');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 熟女魅力 | 成熟女性的时尚与生活美学平台"
        description="熟女魅力是一个专为30岁以上成熟女性打造的生活方式内容平台。了解我们的品牌故事、核心价值与联系方式，一起探索熟女的独特魅力。"
        keywords="熟女魅力,关于我们,熟女平台,女性生活方式,联系我们"
        canonicalUrl="https://elegantvibe.github.io/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema, null, 2) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema, null, 2) }}
      />
      <Navbar />
      <main className="min-h-screen pt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="py-12 md:py-16">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                关于熟女魅力
              </h1>
              <p className="text-foreground-500 font-label leading-relaxed text-base max-w-2xl mx-auto">
                熟女魅力成立于2024年，是一个专为30岁以上成熟女性打造的生活方式内容平台。
                我们相信，每一位女性在经历岁月的沉淀后，都能绽放出独特的魅力与光彩。
                通过精心创作的时尚穿搭、护肤保养、生活美学和自我成长内容，我们致力
                于帮助每一位熟女发现并展现自己最美的一面。
              </p>
            </div>
          </section>

          <section className="py-12 md:py-16 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-5xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5">
                    <i className="ri-lightbulb-line text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                    我们的使命
                  </h3>
                  <p className="text-sm text-foreground-500 font-label leading-relaxed">
                    帮助每一位成熟女性发现自身魅力，通过专业内容赋能，让熟女魅力更加耀眼动人。
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-5">
                    <i className="ri-eye-line text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                    我们的愿景
                  </h3>
                  <p className="text-sm text-foreground-500 font-label leading-relaxed">
                    成为华语世界最具影响力的熟女生活方式平台，引领成熟女性的时尚与生活美学潮流。
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-600 mb-5">
                    <i className="ri-heart-line text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                    核心价值观
                  </h3>
                  <p className="text-sm text-foreground-500 font-label leading-relaxed">
                    真实、专业、温暖。我们坚持原创内容，用真诚的态度和专业的视角服务每一位读者。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16">
            <div className="max-w-5xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                读者口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {testimonials.map((t, idx) => (
                  <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-label font-medium text-sm">
                        {t.name[0]}
                      </div>
                      <div>
                        <p className="text-sm font-label font-medium text-foreground-800">{t.name}</p>
                        <p className="text-xs text-foreground-400 font-label">{t.age}岁 · {t.location}</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 font-label leading-relaxed">
                      &ldquo;{t.text}&rdquo;
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                常见问题
              </h2>
              <div className="space-y-3">
                {faqs.map((faq, idx) => (
                  <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
                    <button
                      onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                      className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                    >
                      <span className="text-sm font-label font-medium text-foreground-800">{faq.question}</span>
                      <span className={`transition-transform duration-200 ${openFaq === idx ? 'rotate-45' : ''}`}>
                        <i className="ri-add-line text-foreground-500"></i>
                      </span>
                    </button>
                    {openFaq === idx && (
                      <div className="px-6 pb-4">
                        <p className="text-sm text-foreground-500 font-label leading-relaxed">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16">
            <div className="max-w-2xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <p className="text-foreground-500 font-label text-sm text-center mb-10">
                有任何问题、建议或合作意向？欢迎通过以下表单与我们联系
              </p>

              {formStatus === 'success' ? (
                <div className="bg-secondary-100 text-secondary-700 rounded-xl p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-200 text-secondary-600 mb-4">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <p className="font-label text-sm">{formMessage}</p>
                </div>
              ) : (
                <form
                  onSubmit={handleContactSubmit}
                  data-readdy-form
                  className="space-y-5"
                >
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label htmlFor="name" className="block text-sm font-label font-medium text-foreground-700 mb-2">姓名</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        placeholder="请输入你的姓名"
                        className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm font-label text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-label font-medium text-foreground-700 mb-2">邮箱</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="请输入你的邮箱"
                        className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm font-label text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-label font-medium text-foreground-700 mb-2">主题</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      placeholder="请输入留言主题"
                      className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm font-label text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-label font-medium text-foreground-700 mb-2">留言内容</label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      placeholder="请输入你的留言内容（最多500字）"
                      className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm font-label text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 disabled:opacity-50 text-background-50 font-label font-medium rounded-full transition-all duration-300 text-sm cursor-pointer"
                  >
                    {formStatus === 'loading' ? '提交中...' : '发送留言'}
                  </button>
                </form>
              )}
              {formStatus === 'error' && (
                <p className="text-red-500 text-sm mt-3 font-label text-center">{formMessage}</p>
              )}

              <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <p className="text-sm font-label font-medium text-foreground-800">电子邮箱</p>
                  <p className="text-xs text-foreground-400 font-label mt-1">contact@shunvmeili.com</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-wechat-line text-xl"></i>
                  </div>
                  <p className="text-sm font-label font-medium text-foreground-800">微信公众号</p>
                  <p className="text-xs text-foreground-400 font-label mt-1">熟女魅力官方</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <p className="text-sm font-label font-medium text-foreground-800">工作时间</p>
                  <p className="text-xs text-foreground-400 font-label mt-1">周一至周五 9:00-18:00</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}